import type { JSX } from 'react';

import { Container } from '@change-corgi/design-system/layout';

import type { ErrorHandlerProps } from 'src/app/pages/petitionUpdate/details/pageContext';

export function PetitionUpdateErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	return <Container variant="small">{`Failed to retrieve data for PetitionUpdate page (error: ${error})`}</Container>;
}
